<template>
  <div id="maillist">maillist</div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
export default {
  mixins: [part],
  name: "maillist",
};
</script>

<style>
</style>